import * as Api from '@ViewModels';
import { IContentCalendarSelectedSuggestion } from '../index';

/**
 * Suggestion sources that should not be sent to bulk AI content generation.
 */
export const isBulkAiExcludedSource = (source?: Api.ContentCalendarSuggestionSource): boolean =>
	source === 'Custom' || source === 'CustomContentTemplate';

/**
 * True when a suggestion may be included in a bulk "Make Content Unique with AI" run.
 */
export const isBulkAiEligible = (suggestion: IContentCalendarSelectedSuggestion): boolean =>
	!isBulkAiExcludedSource(suggestion.source) && !suggestion.customizedForAccount;

/**
 * True when at least one selected suggestion may be included in a bulk "Make Content Unique with AI" run.
 * Empty list returns false (nothing to run).
 */
export const hasAnyBulkAiEligibleSuggestion = (suggestions: IContentCalendarSelectedSuggestion[]): boolean =>
	suggestions.some(isBulkAiEligible);
